import type { ClientModule } from "./types";
import { activityModule } from "./modules/activity";
import { agentModule } from "./modules/agent";
import { aiAgentsModule } from "./modules/aiAgents";
import { appModule } from "./modules/app";
import { appControllerModule } from "./modules/appController";
import { contactModule } from "./modules/contact";
import { contactUiModule } from "./modules/contactUi";
import { emailModule } from "./modules/email";
import { extensibilityModule } from "./modules/extensibility";
import { fileModule } from "./modules/file";
import { messageTemplateModule } from "./modules/messageTemplate";
import { quickResponsesModule } from "./modules/quickResponses";
import { settingsModule } from "./modules/settings";
import { userModule } from "./modules/user";
import { voiceModule } from "./modules/voice";

/**
 * Every registered client. `@amazon-connect/site-streams` is deliberately absent: it targets a
 * host page embedding CCP, not an app running inside the workspace. `@amazon-connect/theme`
 * exposes styling helpers, not events, and cannot even be imported in a Node/vitest context
 * (it fails on a Cloudscape ESM directory import). `@amazon-connect/core` is plumbing.
 */
export const registry: readonly ClientModule[] = [
  contactModule,
  agentModule,
  voiceModule,
  settingsModule,
  emailModule,
  activityModule,
  aiAgentsModule,
  appModule,
  userModule,
  fileModule,
  appControllerModule,
  messageTemplateModule,
  quickResponsesModule,
  contactUiModule,
  extensibilityModule,
];

/** Looks a module up by id. */
export function getModule(id: string): ClientModule | undefined {
  return registry.find((m) => m.id === id);
}

export * from "./types";
